import React from "react";
import PropTypes from "prop-types";
import "./PageHeader.scss";

const PageHeader = ({ title, description }) => {
  return (
    <div className="pens-page-header">
      <div className="container-fluid">
        <div className="pens-page-header__inner">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default PageHeader;
